import { UIFetchStatus, UIFlightData } from "@flights/types";
import { isOfMetaOrigin } from "../../../../../utils/marketing-url-params";
import flights_web_fd_baggage_transparency, {
  useTrackBaggageTransparencyFD
} from "../../../../../utils/experiments/funnel/flights_web_fd_baggage_transparency";
import useBaggageInfo from "./Items/BaggageInfo/useBaggageInfo";
import useDetailedBaggageInfo from "./Items/DetailedBaggageInfo/useDetailedBaggageInfo";
import useGeniusRewardsInfo from "./Items/GeniusRewardsInfo/useGeniusRewardsInfo";
import useFareRulesInfo from "./Items/FareRulesInfo/useFareRulesInfo";
import useExtraProductsInfo from "./Items/ExtraProductsInfo/useExtraProductsInfo";
import useExtraProductsInfo2 from "./Items/ExtraProductsInfo2/useExtraProductsInfo2";
import useTicketTypeInfo from "./Items/TicketTypeInfo/useTicketTypeInfo";
import useFareRulesStatusInfo from "./Items/FareRulesStatusInfo/useFareRulesStatusInfo";
import useAtolInfo from "./Items/AtolInfo/useAtolInfo";
import useOneWayCombinationInfo from "./Items/OneWayCombinationInfo/useOneWayCombinationInfo";
import useRyanairHungaryInfo from "./Items/RyanairHungaryInfo/useRyanairHungaryInfo";
import useUserAgent from "../../../../../hooks/useUserAgent";
import useUpgradeFareInfoDesktop from "./Items/UpgradeFareInfo/useUpgradeFareInfo.desktop";
import useUpgradeFareInfoMobile from "./Items/UpgradeFareInfo/useUpgradeFareInfo.mobile";
import { useTrackFareRulesAADiff } from "../../../../../utils/experiments/funnel/flights_web_fare_rules_aa_legs_diff";

type Props = {
  flight: UIFlightData;
  fetchStatus: UIFetchStatus;
};

const useFlightDetailsInfoController = ({ flight, fetchStatus }: Props) => {
  const { isMobile } = useUserAgent();

  const baggageInfo = useBaggageInfo(flight);
  const detailedBaggageInfo = useDetailedBaggageInfo(flight);
  const geniusRewardsInfo = useGeniusRewardsInfo(flight);
  const fareRulesInfo = useFareRulesInfo(flight);
  const extraProductsInfo = useExtraProductsInfo(flight);
  const extraProductsInfo2 = useExtraProductsInfo2(flight);
  const ticketTypeInfo = useTicketTypeInfo(flight);
  const fareRulesStatusInfo = useFareRulesStatusInfo(flight);
  const atolInfo = useAtolInfo(flight);
  const oneWayCombinationInfo = useOneWayCombinationInfo(flight);
  const ryanairHungaryInfo = useRyanairHungaryInfo(flight);
  const upgradeFareInfoMobile = useUpgradeFareInfoMobile(flight);
  const upgradeFareInfoDesktop = useUpgradeFareInfoDesktop(flight);

  useTrackBaggageTransparencyFD(flight, fetchStatus === "success");
  useTrackFareRulesAADiff(flight);

  return {
    isLoading: fetchStatus === "loading" && !isOfMetaOrigin(),
    items: [
      flights_web_fd_baggage_transparency.trackWithDefaultStage() ? detailedBaggageInfo : baggageInfo,
      geniusRewardsInfo,
      fareRulesInfo,
      isMobile ? upgradeFareInfoMobile : upgradeFareInfoDesktop,
      extraProductsInfo,
      extraProductsInfo2,
      ticketTypeInfo,
      fareRulesStatusInfo,
      atolInfo,
      oneWayCombinationInfo,
      ryanairHungaryInfo
    ].filter((i) => !!i)
  };
};

export default useFlightDetailsInfoController;
